import { render, staticRenderFns } from "./AddOrder.vue?vue&type=template&id=08f1ec1e"
import script from "./AddOrder.vue?vue&type=script&lang=js"
export * from "./AddOrder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports